<template>
  <div class="header">
    <router-link :to=" { path:'/' } ">
      <img src="../../assets/images/logo.png" class="logo" alt="">
    </router-link>
    <img src="../../assets/images/menu.png" class="btn" alt="" @click="clickMenu()">
    <!-- 右侧弹出层 -->
    <nut-popup
      position="top"
      v-model:visible="show"
      :style="{ height: 'auto' }"
    >
    <div class="memu_about">
      <span>关于博雅数字</span>
    </div>
    <div class="menu">
      <ul>
        <router-link :to=" { path:'/about' } "><li>公司介绍</li></router-link>
        <router-link :to=" { path:'/jobs' } "><li>招贤纳士</li></router-link>
        <router-link :to=" { path:'/concant' } "><li>联系我们</li></router-link>
      </ul>
    </div>
    </nut-popup>
  </div>
</template>
<script>
export default {
  components: {

  },
  data() {
    return {
      show: false,
    }
  },
  created() {

  },
  methods: {
    clickMenu() {
      this.show = !this.show;
      console.log(this.show);
    },
  }
}
</script>
<style scoped>
.header {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 3000;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 32px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.10); 
}
.header .logo {
  display: block;
  width: 232px;
  height: 64px;
}
.header .btn {
  display: block;
  width: 48px;
  height: 48px;
}
.memu_about {
  margin-top: 122px;
  padding: 32px;
  box-sizing: border-box;
  font-size: 24px;
  color: #333;
  font-weight: bold;
  border-bottom: 1px solid #ededed;
}
.menu ul {
  padding: 0 32px;
  box-sizing: border-box;
}
.menu ul li {
  font-size: 24px;
  line-height: 80px;
  font-weight: 500;
  border-bottom: 1px solid #ededed;
}

</style>